export const getItemImages = (image) => ((typeof image) === 'string' ? image : (image?.image || image?.image_med));
